export default __webpack_public_path__ + "static/media/DevWeb.8d7f2c35.png";